export class UserSession {
    cardNo: number;
    cardID: number;
    profile_type: number;
    client_id: number;
    profile_id: number;
    userId: number;
    userFullName: string;
    roleType: number
    roleId: number;
    filterresellerId: number;
    filterclientId: number;
    filterprofileTypeId: number;
    authToken: string;
    roleName: string;
    defaultreseller: number
    email: string;
    mobileNumber: string;
    languageType: number;
    clientId: any = [];
    currentClientId: any;
    currentClientName: any;
    isDynamicPassword: boolean;
    role: number;
    subDivisionId: number;
    regionId: number;
    divisionId: number;
    filterdivisionId: number;
    filterregionId: number
    filtersubdivisionId: number;
    card_number_mask: any;
    cardholdername: any;
    tracking_no: any
}
